interface iBonds {
  accrued_interest: number;
  bonds_price: string;
  coupon_tax_percentage: string;
  icon: string;
  product_name: string;
  stamp_duty: number;
}

export interface iHistoryRecord {
  command?: string;
  date?: Date;
  display_as?: string;
  symbol?: string;
  company_name?: string;
  available_lot?: number;
  available_share?: number;
  balance_lot?: number;
  balance_share?: number;
  netamount?: number;
  sell_open?: number;
  sell_open_today?: number;
  total?: number;
  price?: number;
  price_average?: number;
  price_average_fee?: number;
  price_latest?: number;
  unrealised_marketvalue?: number;
  unrealised_profitloss?: number;
  unrealised_gain?: number;
  security?: string;
  amount_invested?: number;
  exercise_data?: PortfolioExercise;
  allow_order?: number;
  stock_on_hand?: number;
  have_smartorder?: boolean;
  show_create_smartorder?: boolean;
  bonds?: iBonds;
  time?: string;
  is_day_trade?: boolean;
}

// eslint-disable-next-line no-shadow
export enum HistoryType {
  BUY = 'BUY',
  SELL = 'SELL',
  FORCED_SELL_DAY_TRADE = 'FORCE SELL DAY TRADE',
  DEPOSIT = 'DEPOSIT',
  CASHBACK_STOCKBIT = 'CASHBACK STOCKBIT',
  CASHBACK_BROKER_FEE = 'CASHBACK BROKER FEE',
  WITHDRAW = 'WITHDRAW',
  EXERCISE = 'EXC',
  DIVIDEND = 'DIV',
  IPO = 'IPO',
  REFUND = 'REFUND',
  METERAI = 'METERAI',
  STAMP_DUTY_WITHDRAW = 'STAMP_DUTY_WITHDRAW',
  CONVERSION = 'CONVERSION',
  BUY_FR = 'BUY_FR',
  SELL_FR = 'SELL_FR',
  REFUND_FR = 'REFUND_FR',
  COUPON_FR = 'COUPON_FR',
  COUPON_KAEF01CB = 'COUPON_KAEF01CB',
  COUPON_SBN = 'COUPON_SBN',
  DATA_FEE = 'DATA FEE',
  LATE_FEE = 'LATE FEE',
  SBN_EARLY_REDEMPTION = 'SBN_EARLY_REDEMPTION',
  SBN_MATURITY_REDEMPTION = 'SBN_MATURITY_REDEMPTION',
  SBN_WITHDRAW = 'SBN_WITHDRAW',
  FR_MATURITY_REDEMPTION = 'FR_MATURITY_REDEMPTION',
  BOND_REDEMPTION = 'BOND_REDEMPTION',
  IFA_WITHDRAW = 'IFA_WITHDRAW',
  INTRA_MOVE_CASH = 'INTRA_MOVE_CASH',
  INTRA_MOVE_CASH_INCREASE = 'INTRA_MOVE_CASH_INCREASE',
  INTRA_MOVE_STOCK = 'INTRA_MOVE_STOCK',
  INTRA_MOVE_STOCK_INCREASE = 'INTRA_MOVE_STOCK_INCREASE',
  CAPITAL_REDUCTION = 'CAPITAL_REDUCTION',
  SWEEP_IN = 'SWEEP_IN',
  SWEEP_OUT = 'SWEEP_OUT',
}

export const FR_BONDS: string[] = [
  HistoryType.BUY_FR,
  HistoryType.SELL_FR,
  HistoryType.REFUND_FR,
  HistoryType.COUPON_FR,
];

export const BONDS: string[] = [
  ...FR_BONDS,
  HistoryType.COUPON_KAEF01CB,
  HistoryType.COUPON_SBN,
];

export const COUPONS: string[] = [
  HistoryType.COUPON_FR,
  HistoryType.COUPON_KAEF01CB,
  HistoryType.COUPON_SBN,
];

export const REDEMPTIONS: string[] = [
  HistoryType.SBN_EARLY_REDEMPTION,
  HistoryType.SBN_MATURITY_REDEMPTION,
  HistoryType.FR_MATURITY_REDEMPTION,
  HistoryType.BOND_REDEMPTION,
];

export const TRANSFERS: string[] = [
  HistoryType.INTRA_MOVE_CASH,
  HistoryType.INTRA_MOVE_CASH_INCREASE,
  HistoryType.INTRA_MOVE_STOCK,
  HistoryType.INTRA_MOVE_STOCK_INCREASE,
];

export enum HistoryTab {
  ALL = 'all',
  REALIZED = 'realized',
}

export enum RealizedFilterEnum {
  STOCK_REALIZED = 'stockrealized',
  STOCK_DIVIDEND = 'dividendrealized',
  BOND_REALIZED = 'bondrealized',
  BOND_COUPON = 'couponrealized',
}

export enum HistoryStatus {
  SUCCESS = 'Success',
  PENDING = 'Pending',
  FAILED = 'Failed',
}

export const TransferCash: string[] = [
  HistoryType.INTRA_MOVE_CASH,
  HistoryType.INTRA_MOVE_CASH_INCREASE,
];

export const TransferStock: string[] = [
  HistoryType.INTRA_MOVE_STOCK,
  HistoryType.INTRA_MOVE_STOCK_INCREASE,
];

export const ShowTransferStatus: string[] = [
  HistoryStatus.SUCCESS,
  HistoryStatus.FAILED,
];
